/**
 * Responsive overlay tokens and constants (ADR-114).
 *
 * These are the single source of truth for the responsive primitives shared
 * by admin-console, agent-ui and account-ui. Keep them in sync with
 * docs/design/ui-platform/responsive-overlays-lld.md §1.2/§9.
 */

/** Viewport width at which content overlays stop being bottom-sheets. */
export const SHEET_BREAKPOINT = 640;

/** Viewport width at which the main navigation stops being a drawer. */
export const NAV_BREAKPOINT = 1024;

/** Minimum touch target size (px) for primary actions on coarse pointers. */
export const TOUCH_TARGET_MIN = 44;

/** Maximum height of a centered dialog. */
export const OVERLAY_MAX_HEIGHT_CLASS = 'max-h-[min(85dvh,900px)]';

/** Maximum height of a bottom-sheet. */
export const SHEET_MAX_HEIGHT_CLASS = 'max-h-[90dvh]';

/** Dialog width by archetype (desktop; mobile always uses calc(100vw - 2rem)). */
export const OVERLAY_SIZE_CLASS = {
  sm: 'max-w-sm',
  md: 'max-w-lg',
  lg: 'max-w-2xl',
  xl: 'max-w-4xl',
} as const;

export type OverlaySize = keyof typeof OVERLAY_SIZE_CLASS;
